import {
  ArrowDownOutlined,
  ArrowRightOutlined,
  ArrowUpOutlined,
} from '@ant-design/icons';
import { FC } from 'react';

import { TrendDirection } from '../../types';

export const TrendIndicator: FC<{
  direction: TrendDirection;
  color: string;
  label: string;
}> = ({ direction, color, label }) => (
  <span style={{ color, fontSize: 12, fontWeight: 800 }}>
    {direction === 'up' ? (
      <ArrowUpOutlined style={{ marginRight: 2 }} />
    ) : direction === 'down' ? (
      <ArrowDownOutlined style={{ marginRight: 2 }} />
    ) : (
      <ArrowRightOutlined style={{ marginRight: 2 }} />
    )}
    {label}
  </span>
);
